import { createSlice } from '@reduxjs/toolkit';

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    items: [],
    totalQuantity: 0,
    totalPrice: 0,
  },
  reducers: {
    addToCart: (state, action) => {
      const item = action.payload;
      const existingItem = state.items.find((i) => i.id === item.id);
      
      if (existingItem) {
        existingItem.quantity += item.quantity;
        existingItem.totalPrice += item.price * item.quantity;
      } else {
        state.items.push({
          ...item,
          id:item.id,
          img:item.img,
          quantity: item.quantity,
          totalPrice: item.price * item.quantity,
          cannotAdd:false,
          cannotRemove:false
        });
      }
      state.totalQuantity += item.quantity;
      state.totalPrice += item.price * item.quantity;
    }, 
    updateToCart: (state, action) => { 
      const index = action.payload.idx;
      const newVal = action.payload.newVal;
      if (!state.items[index]) return;
      const newItem = state.items[index];

      state.items[index].cannotAdd = false;
      state.items[index].cannotRemove = false;
    
      // remove last item 
      state.totalQuantity -= state.items[index].quantity;
      state.totalPrice -= state.items[index].price * state.items[index].quantity;
      
      // calculate new item
      const maxQuantity =   parseInt(state.items[index].detail.count - state.items[index].detail.sold_amount);
      
      if(newVal === -1){

        if((state.items[index].quantity - 1) <= 0)
          state.items[index].quantity = 1
        else
          state.items[index].quantity -= 1;

      }
      else if( maxQuantity < (newItem.quantity + 1)){
        state.items[index].quantity = maxQuantity;
        state.items[index].cannotAdd = true;
      }else {
        state.items[index].quantity +=1;
      }

      state.items[index].cannotRemove =  state.items[index].quantity === 1? true:false;
      
      state.items[index].totalPrice = state.items[index].price * state.items[index].quantity;

      state.totalQuantity +=  state.items[index].quantity;
      state.totalPrice += state.items[index].price * state.items[index].quantity;
    },
    removeFromCart: (state, action) => {
      const id = action.payload;
      const itemIndex = state.items.findIndex((i) => i.id === id);
      const item = state.items[itemIndex];

      if (item) {
        state.totalQuantity -= item.quantity;
        state.totalPrice -= item.totalPrice;
        state.items.splice(itemIndex, 1);
      }
    },
    clearCart: (state) => {
      state.items = [];
      state.totalQuantity = 0;
      state.totalPrice = 0;
    },
    updateCartMismatching:(state,action) => {
      // The server returns only mismatching variants. Preserve every other item.
      const changes = new Map(action.payload.map((item) => [String(item.variant_id), item]));
      state.items = state.items.map((item) => {
        const change = changes.get(String(item.id));
        if (!change) return item;
        const available = Math.max(0, Number(change.count));
        const quantity = Math.min(item.quantity, available);
        const price = Number(change.price);
        return {
          ...item, quantity, price, totalPrice: price * quantity,
          detail: { ...item.detail, count: available, sold_amount: 0, price },
          cannotAdd: quantity >= available, cannotRemove: quantity <= 1,
        };
      }).filter((item) => item.quantity > 0);
      state.totalQuantity = state.items.reduce((sum, item) => sum + item.quantity, 0);
      state.totalPrice = state.items.reduce((sum, item) => sum + item.totalPrice, 0);
    }
  },
});

export const { addToCart,updateToCart ,removeFromCart, clearCart,updateCartMismatching } = cartSlice.actions;
export default cartSlice.reducer;
